import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data) => {
    const token = await getToken();
    const res = await axios({ method, url: `${API}${url}`, data, headers: token ? { Authorization: `Bearer ${token}` } : {} });
    return res.data;
  }, [getToken]);
}

export function useFetch(url, deps = [], enabled = true) {
  const api = useApi();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try { setData(await api("get", url)); } catch { setData(null); }
    setLoading(false);
  }, [api, url, enabled]); // eslint-disable-line
  useEffect(() => { reload(); }, [reload, ...deps]); // eslint-disable-line
  return { data, loading, reload, setData };
}

export const errMsg = (e) => e?.response?.data?.detail || "Une erreur est survenue";

export const isVideo = (u) => /\.(mp4|mov|webm)$/i.test(u || "");
export const imgUrl = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
